import * as cnames from 'classnames'
import * as React from 'react'

import { IItemCard } from '../interface'

import HoverFocusObserver from '../../hoverFocusObserver'
import ItemCardSmallPreview from '../itemCardSmallPreview'
import LockupAudioPreview from '../lockupAudioPreview'
import LockupAudioTrackInfo from '../lockupAudioTrackInfo'
import LockupActionPanel from '../lockupListActionPanel'
import LockupTitleAuthor from '../lockupTitleAuthor'

import * as styles from './itemCardAudioContent.module.css'

const ItemCardAudioContent = (props: IItemCard) => {
  const { viewType } = props
  const isGrid = viewType === 'grid'

  return (
    <HoverFocusObserver className={styles.root}>
      {({ isHovered, isFocused }) => {
        const downloadHighlight = isFocused || isHovered
        return (
          <React.Fragment>
            <div
              className={cnames(styles.trackInfo, {
                [styles.trackInfoGrid]: isGrid
              })}
            >
              <LockupAudioPreview {...props} />

              <LockupAudioTrackInfo {...props} />
            </div>
            <div
              className={cnames(styles.itemInfo, {
                [styles.itemInfoGrid]: isGrid
              })}
            >
              <span
                className={cnames(styles.title, {
                  [styles.titleGrid]: isGrid
                })}
              >
                <span className={styles.icon}>
                  <ItemCardSmallPreview {...props} />
                </span>
                <LockupTitleAuthor inline={!isGrid} {...props} />
              </span>
              <span
                className={cnames(styles.icons, { [styles.gridIcons]: isGrid })}
              >
                <LockupActionPanel
                  {...props}
                  includeDownload={true}
                  downloadHighlight={downloadHighlight}
                />
              </span>
            </div>
          </React.Fragment>
        )
      }}
    </HoverFocusObserver>
  )
}

export default ItemCardAudioContent
